<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br />
    <span>{{ "LBL_CONSULTANDO" | translate }}</span>
  </div>
</div>
<div class="grid" *ngIf="!carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12">
    <p-panel header="{{ 'GRUPO.LBL_INFORMACIONESTRUCTURAFISICA' | translate }}">
      <div class="grid">
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ "GRUPO.LBL_CODIGO" | translate }}:</label>
        <label class="lg:col-3 col-6 md:col-8"><strong>{{ estructuraFisica.codigo }}</strong></label>
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ "GRUPO.LBL_ESTRUCTURAFISICA" | translate }}:</label>
        <label class="lg:col-3 col-6 md:col-8"><strong>{{ estructuraFisica.estructuraFisica }}</strong></label>
      </div>
      <div class="grid">
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ "GRUPO.LBL_DIRECCION" | translate }}:</label>
        <label class="lg:col-3 col-6 md:col-8"><strong>{{ estructuraFisica.direccion }}</strong></label>
      </div>
      <div style="display: flex; justify-content: center">
        <div style="display: flex; border: 1px solid #b8b6b6; align-items: center; border-radius: 10px;">
          <div style="width: 83px; margin: 0 9px 0 9px; text-align: center">
            <p style="font-weight: 600">{{('ESTRUCTURAFISICA.LBL_TIPODEAPROBACION' | translate) | uppercase }}</p>
          </div>
          <div style="width: 63px; text-align: center; margin: 0 0px 0 9px">
            <p style="font-weight: 600">{{'ESTRUCTURAFISICA.LBL_PORNIVELES' | translate }}</p>
          </div>
          <div style="margin: 0 9px 0 0px">
            <p-inputSwitch [(ngModel)]="isSwitchOn" (onChange)="actualizarEstructuraFisica()"></p-inputSwitch>
          </div>
          <div style="text-align: center; margin: 0 9px 0 9px; width: 91px">
            <p style="font-weight: 600">{{'ESTRUCTURAFISICA.LBL_RESTRICCIONDEAPROBACION' | translate }}</p>
          </div>
        </div>
      </div>
    </p-panel>
  </div>

  <div *ngIf="isSwitchOn" class="col-12 md:col-6 lg:col-6 flex justify-content-start">
    <form [formGroup]="formulario" (ngSubmit)="agregarEstructuraFisicaUsuarioProceso()" novalidate id="formulario"
      name="formulario" class="flex col-12 align-items-center justify-content-start px-0">
      <div class="col-12 md:col-6 lg:col-6 px-0">
        <div class="div-form">
          <label>*{{ 'ESTRUCTURAFISICA.LBL_USUARIOAPROBADORES' | translate}}</label>
          <p-multiSelect id="idUsuarioProceso" name="nomidUsuarioProceso" [options]="lisUsuariosProcesos"
            filter="filter"
            defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
            selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
            formControlName="idsUsuarioProceso"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idsUsuarioProceso.invalid">
            {{ 'ESTRUCTURAFISICA.LBL_USUARIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3" style="display: flex; align-items: flex-end; margin-top: 15px; margin-left: 50px;">
        <button type="submit" pButton icon="fa fa-plus" label="{{ 'BTN_AGREGAR' | translate }}"></button>
      </div>
    </form>
  </div>
  <div *ngIf="!isSwitchOn" class="col-12 md:col-6 lg:col-6" style="display: flex; align-items: flex-end">
    <button type="button" pButton icon="fa fa-plus" (click)="crear()" label="{{ 'BTN_AGREGAR' | translate }}"></button>
  </div>
  <div *ngIf="!isSwitchOn" class="col-12 md:col-6 lg:col-6"
    style="display: flex; flex-direction: column; justify-content: flex-end">
    <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
      (input)="dt.filterGlobal($event.target.value, 'contains')" name="busGrupo" [(ngModel)]="busqueda"
      (change)="setBusqueda()" />
  </div>

  <div *ngIf="!isSwitchOn" class="col-12 md:col-12 lg:col-12">
    <p-table [columns]="columnas" #dt [value]="grupos" selectionMode="single" dataKey="idGrupo" [paginator]="true"
      [rows]="10"  paginatorPosition="bottom" [globalFilterFields]="['nombre']">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
            class="text-center">
            {{ col.header }}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [pSelectableRow]="row">
          <td>{{ row.codigo }}</td>
          <td>{{ row.nombre }}</td>
          <td>{{ row.nombreUsuario }}</td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
          </td>
          <td class="text-center">
            <div class="btn-group" role="group">
              <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                title="{{ 'BTN_VISUALIZAR' | translate }}" pButton (click)="ver(row)"></button>
              <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                title="{{ 'BTN_EDITAR' | translate }}" pButton (click)="editar(row)"></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td class="text-center" [attr.colspan]="columns.length">
            {{ "MSG_NOHAYREGISTROS" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div *ngIf="isSwitchOn" class="col-12 md:col-12 lg:col-12">
    <p-table [columns]="columnas2" #dtEstructuras [value]="estructurasFisicasUsuariosProcesosFiltrados"
      selectionMode="single" dataKey="idGrupo" [paginator]="true" [rows]="10"
      paginatorPosition="bottom" [loading]="carTabla">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
            class="text-center">
            {{ col.header }}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [pSelectableRow]="row">
          <td>{{ row.nombreApellido }}</td>
          <td>{{ row.rol }}</td>
          <td>{{ row.nivel }}</td>
          <td>{{ row.nivelRango }}</td>
          <td>{{ row.montoAprobacion }}</td>
          <td>{{ row.tipoAprobacion }}</td>
          <td class="text-center">
            <div class="btn-group" role="group">
              <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                title="{{ 'BTN_ELIMINAR' | translate }}" (click)="inhabilitarRegistro(row)" pButton></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td class="text-center" [attr.colspan]="columns.length">
            {{ "MSG_NOHAYREGISTROS" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

</div>

<p-confirmDialog #cd key="confirmacion">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
